import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
    resources: {
        en: { translation: require('./locales/en.json') },
        de: { translation: require('./locales/de.json') },
        sr: { translation: require('./locales/sr.json') },
        fr: { translation: require('./locales/fr.json') },
        ru: { translation: require('./locales/ru.json') },
    },
    lng: 'sr',
    fallbackLng: 'sr',
    interpolation: { escapeValue: false },
});

export default i18n;
